import { Directive, ElementRef, Inject, OnInit } from '@angular/core';

import { TranslationService } from './translation.service';

@Directive({
    selector: '[translate]',
    standalone: false
})
export class TranslationDirective implements OnInit
{
  constructor(
    private el: ElementRef,
    @Inject(TranslationService) private translationService
  ) { }

  public ngOnInit(): void
  {
    const input = this.el.nativeElement.innerText.trim();
    if (input.length > 5) {
      const splitted = input.split(' ');
      let key = '';
      let value = 1;

      if (splitted.length > 1) {
        [value, key] = splitted;
      } else {
        [key] = splitted;
      }

      this.el.nativeElement.innerHTML =
          this.el.nativeElement.innerHTML.replace(input,
              this.translationService.get(key, value));
    }
  }
}
